<div class="container custom-container">
  <div class="row">
    <div class="col-auto p-0">
      <app-sidenav></app-sidenav>
    </div>
    <div class="col p-0">
      <div class="p-0 mt-0" style="background-color: #fff;width: 100%;height: 100%;">
        <app-header></app-header>
        <div class="main-block">
          <div class="d-flex justify-content-between align-items-start wrap-block create-col" style="flex-direction: column;">
            <div class="mt-2" style="display: flex;justify-content: space-between;width: 100%;">
              <div class="flex" style="display: flex;gap:20px">
                <div style="margin-right: 20px;" class="form-search-sub">
                  <mat-form-field style="width: 100%; margin-top: auto;">


                    <mat-select [(value)]="selectedAssigner" class="user-select" placeholder="Status"
                      (selectionChange)="onSelectChanges($event)" panelClass="custom-dropdown-panel"
                      disableOptionCentering>
                      <mat-option [value]="''">
                        Select Status
                      </mat-option>
                      <mat-option *ngFor="let role of dropDowns" [value]="role.value">
                        {{role.value == 'Assigned' ? 'Yet to Start' : role.value}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                </div>
                <div style="margin-right: 20px;" class="form-search-sub">
                  <mat-form-field style="width: 100%; margin-top: auto;">
                    <mat-select [(value)]="selectedType" class="user-select" placeholder="User Type"
                      (selectionChange)="onSelectChange($event)" panelClass="custom-dropdown-panel"
                      disableOptionCentering>
                      <mat-option [value]="0">Select User Type</mat-option>
                      <mat-option *ngFor="let role of roleTypes" [value]="role.id">
                        {{ role.role }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="search-form-field">
                  <button (click)="enablefilter(enable)" style=" color: #5D3C6C;
                  font-size: 14px;
                  text-decoration: none;
                  padding: 5px 10px;
                  border: 1px solid #5D3C6C;
                  border-radius: 5px;
                  background-color: white;
                  transition: all 0.3s ease;
                  cursor: pointer;">{{enableName}}<mat-icon style="font-size: 18px;">{{ enable ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon></button>
              </div>
              <div class="search-form-field">
                <button  style=" color: #5D3C6C;
                font-size: 15px;
                text-decoration: none;
                padding: 5px 10px;
                background-color: white;
                border: 1px solid #5D3C6C;
                border-radius: 5px;
                transition: all 0.3s ease;
                cursor: pointer;" (click)="resetFilter()">Reset Filter</button>
              </div>
            </div>

            <div class="flex2">
              <!-- <button type="button" class="btn btn-secondary btn-sm new-btn" style="background-color: #5D3C6C;"
              (click)="openAssignmodule()">
              <img src="assets/img/plus.png" class="btn-img" /> Assign Task
            </button> -->
          </div>
            </div>
            <div class="mt-2" *ngIf="enable">
              
              <div class="mt-2 wrap-block forms-search"
                style="display: flex; align-items: center;margin: 0; justify-content: space-between;flex-direction: row;">
                <div style="margin-right: 20px;display: flex;gap: 20px;" class="form-search-sub">
                  <div>
                    <mat-form-field style="width: 100%; margin-top: auto;">
                      <mat-select [(ngModel)]="selectedCategory" (selectionChange)="oncatogorySelect($event.value)"
                        placeholder="Select Category">
                        <mat-option [value]="0">Select Category</mat-option>
                        <mat-option *ngFor="let category of catagoryDropDown" [value]="category.categoryId">
                          {{ category.categoryName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
  
                  <div *ngIf="isPresent">
                    <mat-form-field style="width: 100%; margin-top: auto;">
                      <mat-select [(ngModel)]="selectedSubCategory" id="roleType"
                        (selectionChange)="onSubcatogorySelect($event.value)" placeholder="Select Sub Category"
                        panelClass="custom-dropdown-panel">
                        <mat-option [value]="0">Select Sub Category</mat-option>
                        <mat-option *ngFor="let role of subCatagoryDropDown" [value]="role.categoryId">
                          {{ role.categoryName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- <mat-form-field style="width: 100%; margin-top: auto;">
                            <mat-select [(value)]="selectedType" 
                                        class="user-select" 
                                        placeholder="User Type"
                                        (selectionChange)="onSelectChange($event)" 
                                        panelClass="custom-dropdown-panel" 
                                        disableOptionCentering>
                              <mat-option [value]="0">All</mat-option>
                              <mat-option *ngFor="let role of roleTypes" [value]="role.id">
                                {{ role.role }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field> -->
  
  
                </div>
                <div class="form-search-sub" >
                  <div class="search-form-field searchType-input" style="margin-left: 20px;">
                    <mat-form-field>
                      <input matInput (keyup)="filterEvent($event)" [(ngModel)]="searchKey"
                        placeholder="Type to Search" />
                    </mat-form-field>
                    <mat-icon class="searchIcon" style="cursor: pointer;" (click)="applyFilter()">search</mat-icon>
  
                  </div>
                 
  
                </div>
                <!-- (keyup)="filterEvent($event)" -->
                <!-- <div class="search-form-field searchType-input">
                                <mat-form-field>
                                  <input matInput  (keyup)="filterEvent($event)" [(ngModel)]="searchKey" placeholder="Type to Search" />
                                </mat-form-field>
                                <mat-icon class="searchIcon" style="cursor: pointer;"(click)="applyFilter($event)" >search</mat-icon>
                              </div> -->
                <!-- (keyup)="filterEvent($event)" -->
               

                <!-- <button type="button" class="btn btn-secondary btn-sm new-btn" style="background-color: #5D3C6C;"
                                (click)="openAddMemberModal()">
                                  <img src="assets/img/plus.png" class="btn-img"/> New Member
                                </button>
                                <button type="button" class="btn btn-secondary btn-sm new-btn" style="background-color: #5D3C6C;"
                                (click)="openbulkInsert()">
                                  Bulk User Import
                                </button> -->


              </div>

            </div>
          




          </div>

          <div class="mat-elevation-z8 member-table table-container mobile-scroll">
            <table mat-table [dataSource]="dataSource" class="mat-table">
              <!-- Ticket ID Column -->
              <ng-container matColumnDef="ticketId">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef> Ticket ID </th>
                <td mat-cell *matCellDef="let element"> {{element.ticketId || 'N/A'}} </td>
              </ng-container>

              <!-- User Type Column -->
              <ng-container matColumnDef="userType">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef> User Type </th>
                <td mat-cell *matCellDef="let element">
                  <span>{{element.userTypeName || 'N/A'}}</span>
                </td>
              </ng-container>

              <!-- Subject Column -->
              <ng-container matColumnDef="subject">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef> Subject </th>
                <td mat-cell *matCellDef="let element" style="width: 30%;"> {{element.subject|| 'N/A'}} </td>
              </ng-container>
              <ng-container matColumnDef="Category/Sub Category">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                  Category / Sub category
                </th>
                <td mat-cell *matCellDef="let row" style="white-space: nowrap;">
                  <span *ngIf="row.parentCategoryId!=0"> {{row.parentCategoryName}} </span>
                  <span *ngIf="row.parentCategoryId==0"> {{'N/A' }} </span>
                  <span *ngIf="row.subCategoryId!=0"> / {{row.subCategoryName}}</span><span
                    *ngIf="row.subCategoryId==0"> / {{'N/A'}}</span>
                </td>
              </ng-container>
              <!-- Comments Column -->
              <ng-container matColumnDef="comments">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef> Comments </th>
                <td mat-cell *matCellDef="let element" style="word-break: break-word;
                min-width: 300px;
                white-space: pre-line;"> {{element.comments|| 'N/A'}} </td>
              </ng-container>

              <!-- Created Date Column -->
              <ng-container matColumnDef="createdDate">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef> Created Date </th>
                <td mat-cell *matCellDef="let element"> {{element.createdDate | date:'dd/MM/yyyy'}} </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element">
                  <span class="badge" [ngStyle]="{
                    'background-color': getStatusColor(element.status),
                  'color': getTextColor(element.status)
               }">{{element.status}}</span>
                  <!-- <span class="badge bg-success-subtle text-success">{{element.status|| 'N/A'}}</span> -->
                </td>
              </ng-container>
              <ng-container matColumnDef="assignedDate">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef> Assigned Date </th>
                <td mat-cell *matCellDef="let element">
                  <span>{{element.assignedDate |  date:'dd/MM/yyyy'}}</span>
                </td>
              </ng-container>
              <!-- Assigned From Column -->
              <ng-container matColumnDef="assignedFrom">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef> Assigned From </th>
                <td mat-cell *matCellDef="let element"> {{element.assignedFrom || 'N/A'}} </td>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="action">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element">
                  <div class="edit-icon" matTooltip="Edit" style="cursor: pointer;" (click)="onClickUpdate(element)">
                    <img src="assets/img/view.png" />
                  </div>
                </td>
              </ng-container>
              <!-- <ng-container matColumnDef="remarks">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef style="width: 30%; text-align: left;">
                  Remarks </th>
                <td mat-cell *matCellDef="let element" style="word-break: break-word;
                        min-width: 300px;
                        white-space: pre-line;"> {{element.remarks || 'N/A'}} </td>
              </ng-container> -->

              <!-- Header and Row Definitions -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>


            <div *ngIf="this.helpDeskList?.length == 0" style="text-align: center;padding: 50px;background-color: white;">
                        <p>no records found </p>
                      </div>

            <mat-paginator [pageSizeOptions]="[5,10, 25, 100]" showFirstLastButtons [length]="length"
              [(pageSize)]="PageSize" [(pageIndex)]="pageNo" (page)="onPaginatorClick($event)" class="metaPaginate">
            </mat-paginator>
          </div>
          <div class="modal fade" id="AssignSupport" data-backdrop="static" tabindex="-1" role="dialog"
          aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div class="modal-dialog">
              <div class="modal-dialog">
                  <div class="modal-content">
                      <!-- Modal Header -->
                      <div class="modal-header">
                          <h4 class="modal-title"> Change Status</h4>
                          <button type="button" class="close" data-dismiss="modal" (click)=" hide()">
                              <!-- <img src="assets/img/modal-close.png" /> -->
                              <mat-icon class="inactive-icon" style="color: red;font-size: 27px;">cancel</mat-icon>
                          </button>
                      </div>
                      <!-- Modal body -->
                      <div class="modal-body mb-3">
                          <!-- Coupon Discount Form -->
                          <div class="modal-body">
                            
       
                                <label for="helpdeskAssigner"> Status</label>
                                 <!-- <select id="helpdeskAssigner"  [(ngModel)]="selectedAssigner">
                                  
                                              <option value='Yet to start'  [disabled]="true">Yet to start</option>
                                              
                                              <option *ngFor="let role of this.dropDown" value="{{role}}">{{role}}</option>
                                            </select> -->
                                            <select id="helpdeskAssigner" [(ngModel)]="selectedAssigners">
                                              <!-- Default option that is disabled -->
                                              <option value="" [disabled]="true">Select status</option>
                                              
                                              <!-- Dynamic options from the dropDown array -->
                                              <option *ngFor="let role of dropDown" [value]="role.value" > {{ role.value == 'Assigned' ? 'Yet to Start' : role.value }}</option>
                                            </select>
                                            <label >Remarks </label>
                                            
                                              <textarea [(ngModel)]="textvalue" placeholder="Remarks" name="remarks" class="textarea"
                                              style="width: 100%; height:120px;border: 1px solid grey; padding: 10px;  transition: border 0.3s ease;"></textarea>
                                            
                                            <button class="sync-btn" style="margin: 15px;" (click)="submit()">Submit</button>
                                
                             
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0, 0, 0, .6)"
  class="spin-img"
  template="<img src='assets/img/logo-D.gif' />"
>
</ngx-spinner>